/// <reference types="vite-plugin-svgr/client" />
import ga4 from './ga4.svg?react';
import shopify from './shopify.svg?react';
import klaviyo from './klaviyo.svg?react';
import meta from './meta.svg?react';
import subdomain from './subdomain.svg?react';
import contextualDark from './contextual-logo-darkmode.svg?react';
import contextualLight from './contextual-logo-lightmode.svg?react';
import postscript from './postscript.svg?react';
import snapchat from './snapchat.svg?react';
import tiktok from './tiktok.svg?react';
import googleads from './googleads.svg?react';
import giphy from './giphy.svg?react';
import insertVariable from './insert-variable.svg?react';
import discountCode from './discount-code.svg?react';
import contactCard from './contact-card.svg?react';
import shortlink from './shortlink.svg?react';
import emoji from './emoji.svg?react';
import media from './media.svg?react';
import google from './google.svg?react';
import ctxSymbol from './ctx_symbol.svg?react';
import shopifyBannerLogo from './shopify-banner-logo.svg?react';
import contextualWordmark from './contextual-wordmark.svg?react';
import circleCheck from './circle-check.svg?react';
import circleDashed from './circle-dashed.svg?react';
import circleDotDashed from './circle-dot-dashed.svg?react';
import circleHalf from './circle-half.svg?react';
import sendlane from './sendlane.svg?react';
import attentive from './attentive.svg?react';
import redo from './redo.svg?react';
import webhook from './webhook.svg?react';
import { useTheme } from '@/layouts/theme-mode-context';
import { cn } from '@/lib/utils';
// Create a proper React component for the contextual logo
const ContextualLogo = (props: React.ComponentProps<typeof contextualDark>) => {
  let theme: 'light' | 'dark' = 'light'; // Default theme
  try {
    const themeContext = useTheme();
    theme = themeContext.theme;
  } catch {
    // If useTheme throws an error (outside ThemeProvider), use default theme
  }
  const Component = theme === 'dark' ? contextualDark : contextualLight;
  return <Component {...props} />;
};

const MAPPING = {
  shopify,
  ga4,
  klaviyo,
  meta,
  subdomain,
  contextual: ContextualLogo,
  postscript,
  snapchat,
  tiktok,
  googleads,
  giphy,
  insertVariable,
  discountCode,
  contactCard,
  shortlink,
  emoji,
  media,
  google,
  contextualWordmark,
  ctxSymbol,
  shopifyBannerLogo,
  circleCheck,
  circleDashed,
  circleDotDashed,
  circleHalf,
  sendlane,
  attentive,
  redo,
  webhook
};

export const Logo = ({
  icon,
  width = 25,
  height = 25,
  className
}: {
  icon: keyof typeof MAPPING;
  width?: number;
  height?: number;
  className?: string;
}) => {
  const Component = MAPPING[icon];
  return (
    <Component
      style={{ width: `${width}px`, height: `${height}px` }}
      width={width}
      height={height}
      className={cn(className)}
    />
  );
};
